import {inject, Injectable} from '@angular/core';
import {FilterService} from "primeng/api";
import {User} from "../../dto/user";

@Injectable({
    providedIn: 'root'
})
export class PrimengCustomizationsService {
    private readonly filterService = inject(FilterService);

    registerCustomizations() {
        this.registerCustomFilterTypes();
    }

    /* Custom filter types - START */

    private registerCustomFilterTypes() {
        this.registerOverlapUsersFilterType();
        this.registerContainsAllPartsFilterType();
    }

    private registerOverlapUsersFilterType() {
        // Register custom filter constraint for overlapping users
        this.filterService.register('overlapUsers', (cellValue: User[] | null | undefined, selected: User[] | null | undefined): boolean => {
            // No selection means no filtering (keep the row)
            if (!selected || selected.length === 0) return true;
            // If row has no users but there is a selection, it cannot match
            if (!cellValue || cellValue.length === 0) return false;
            // Overlap: at least one selected user exists in the cell's users array by id
            return selected.some(s => cellValue?.some(c => c?.id === s?.id));
        });
    }

    private registerContainsAllPartsFilterType() {
        this.filterService.register(
            'containsAllParts',
            (cellValue: string | null | undefined, filterValue: string | null | undefined): boolean => {
                if (!filterValue || filterValue.trim().length === 0) return true;
                if (!cellValue) return false;

                // Pair labels use '#' as the base/quote separator while users
                // naturally type '/' (the readable display form) — treat them
                // as equivalent so "ETH/USDT" matches "ETH#USDT".
                const parts = filterValue
                    .toLowerCase()
                    .replace(/\//g, '#')
                    .split(/\s+/)
                    .filter(Boolean);

                if (parts.length === 0) return true;

                const haystack = cellValue.toLowerCase().replace(/\//g, '#');
                return parts.every(part => haystack.includes(part));
            }
        );
    }

    /* Custom filter types - END */
}
